import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import clsx from 'clsx';
import Logo from './Logo';

const navLinks = [
  { href: '/about', label: 'О нас' },
  { href: '/instructors', label: 'Преподаватели' },
  { href: '/reviews', label: 'Отзывы' },
  { href: '/contact', label: 'Контакты' },
];

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      {/* Mobile Menu Button - Fixed, always on top */}
      <button
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className="md:hidden fixed top-4 right-4 p-2 text-primary bg-cream/95 backdrop-blur-sm rounded-lg shadow-sm"
        aria-label="Меню"
        style={{
          zIndex: 100,
          touchAction: 'manipulation',
          WebkitTapHighlightColor: 'transparent'
        }}
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          {isMenuOpen ? (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          ) : (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          )}
        </svg>
      </button>

      <header className="sticky top-0 z-50 bg-cream/95 backdrop-blur-sm border-b border-secondary/20">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16 md:h-20">
            {/* Logo */}
            <Link to="/" className="flex-shrink-0">
              <Logo />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={clsx(
                    'text-sm font-medium transition-colors',
                    location.pathname === link.href
                      ? 'text-primary'
                      : 'text-secondary hover:text-primary'
                  )}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* Phone - WhatsApp */}
            <a
              href="https://wa.me/79652339933"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:block text-sm font-medium text-primary hover:text-secondary transition-colors"
            >
              +7 (965) 233-99-33
            </a>

            {/* Spacer for fixed button */}
            <div className="md:hidden w-10 h-10"></div>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay - Outside header */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
            className="md:hidden fixed inset-0 top-16 bg-cream z-40 overflow-y-auto"
            style={{ pointerEvents: 'auto' }}
          >
            <nav className="container mx-auto px-4 py-6 flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={clsx(
                    'text-base font-medium py-2 transition-colors',
                    location.pathname === link.href
                      ? 'text-primary'
                      : 'text-secondary'
                  )}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="https://wa.me/79652339933"
                target="_blank"
                rel="noopener noreferrer"
                className="text-base font-medium text-primary py-2"
              >
                +7 (965) 233-99-33
              </a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
